<template>
  <div class="page">
    <el-row>
      <el-col :span="21">
        <el-row class="search-box">
          <slot name="condition" :condition="condition" />
          <el-col :xs="24" :span="3">
            <el-button type="primary" icon="el-icon-search" @click="getPage">查询</el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :xs="24" :span="3" style="text-align: right;">
        <el-tooltip v-if="exportUrl" class="item" effect="dark" content="导出" placement="bottom">
          <el-button style="padding: 7px 7px;" icon="el-icon-download" />
        </el-tooltip>
      </el-col>
    </el-row>

    <div class="content dCardList" style="padding: 0 10px;">
      <slot name="custom" :data="tableData" />
    </div>

    <div class="content dTable">
      <el-table class="dTable" v-loading="loading" :data="tableData" border height="100%">
        <slot />
      </el-table>
    </div>
    <el-row class="footerBox">
      <el-col :span="12">
        <slot name="operateButton" />
      </el-col>
      <el-col :span="12" style="text-align: right">
        <pagination :total="pagination.total" :page.sync="pagination.current" :limit.sync="pagination.size"
          @pagination="getPage" layout="prev, pager, next" />
      </el-col>
    </el-row>
  </div>
</template>

<script>

import Pagination from '@/components/Pagination'
import request from '@/utils/request'

export default {
  name: 'PageTable',
  components: { Pagination },
  props: {
    url: {
      type: String,
      required: true
    },
    exportUrl: String,
    height: {
      type: Number,
      default: window.innerHeight - 185
    }
  },
  data() {
    return {
      showEdit: false,
      showResetPassword: false,
      loading: false,

      // 分页
      pagination: {
        total: 0,
        size: 20,
        current: 1
      },

      condition: {},
      tableData: []

    }
  },
  created() {
    this.getPage()
  },
  methods: {

    getPage() {
      const condition = this.condition
      this.loading = true
      if (!this.condition.date) {
        this.condition.date = [];
      }
      request({
        url: this.url,
        method: 'post',
        data: { condition: condition, pagination: this.pagination }
      }).then((response) => {
        const { current, total, size, records } = response.data
        this.tableData = records
        this.pagination.total = total
        this.pagination.current = current
        this.pagination.size = size
      }).finally(() => {
        this.loading = false
      })
    }

  }

}
</script>

<style scoped>
.search-box {
  padding: 0 10px;
  box-sizing: border-box;
}

.page {
  height: 100%;
  overflow: auto;
  display: flex;
  flex-flow: column wrap;
}

.content {
  width: 100%;
  flex: 1;
  /* display: flex;
  flex-flow: column wrap;
  align-items: center;
  justify-content: center; */
  overflow: auto;
  /* padding: 0 10px; */
  box-sizing: border-box;
}

.footerBox {
  height: 50px;
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

@media screen and (max-width: 768px) {
  .dCardList {
    display: block;
  }

  .dTable {
    display: none;
  }
}

@media screen and (min-width: 768px) {
  .dCardList {
    display: none;
  }

  .dTable {
    display: block;
  }
}
</style>
